// 气血津液辨证模块
// tizhi_qixuejinye 已在 pipeline.parseBase 中完成 JSON.parse
// 雷达图绘制由 Qixuejinye/index.vue 在 mounted / watch 中调用 chart.drawRadar
export default function transform(/* data */) {
    // no-op
}
